(() => {
  if (customElements.get('maxler-variant-interest')) return;

  class MaxlerVariantInterest extends HTMLElement {
    connectedCallback() {
      if (this.form) return;
      const quickProduct = this.closest('[data-qp-product]');
      this.section = quickProduct?.querySelector('[data-qp-form]') || this.closest('[data-section-type="product"]');
      this.form = this.querySelector('form');
      if (!this.section || !this.form) return;

      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.section.addEventListener('variantChange', this.handleVariantChange);
      this.form.addEventListener('submit', this.handleSubmit);
      this.onToggle = () => {
        if (this.hidden || !this.querySelector('details')?.open) return;
        this.protectForm();
        document.dispatchEvent(new CustomEvent('interest_click', {detail: this.eventDetails()}));
      };
      this.querySelector('details')?.addEventListener('toggle', this.onToggle);
      if (!this.hidden && this.querySelector('details')?.open) this.protectForm();
      if (this.form.querySelector('[data-interest-request-success], .errors')) this.querySelector('details').open = true;
      this.emitRequestSuccess();
    }

    disconnectedCallback() {
      if (this.section) this.section.removeEventListener('variantChange', this.handleVariantChange);
      if (this.form) this.form.removeEventListener('submit', this.handleSubmit);
      this.querySelector('details')?.removeEventListener('toggle', this.onToggle);
      this.section = null;
      this.form = null;
      this.captchaProtected = false;
    }

    protectForm() {
      if (this.captchaProtected || !this.form) return;
      if (typeof window.Shopify?.captcha?.protect === 'function') {
        window.Shopify.captcha.protect(this.form);
        this.captchaProtected = true;
      }
    }

    handleVariantChange(event) {
      if (!this.closest('[data-qp-product]')) this.updateVariant(event.detail?.variant);
    }

    updateVariant(variant, {keepVisible = false, helper = ''} = {}) {
      const success = this.querySelector('[data-interest-request-success]');
      const exact = variant?.id != null;
      const unavailable = exact && variant.available === false;
      const visible = unavailable || !exact && keepVisible;
      const variantId = exact ? String(variant.id) : '';
      const variantTitle = exact ? variant.title || '' : '';
      this.dataset.variantId = variantId;
      this.dataset.variantTitle = variantTitle;
      this.hidden = !visible;
      const fields = this.querySelector('[data-interest-fields]');
      if (fields) fields.disabled = !visible;
      const submit = this.querySelector('[data-interest-submit]');
      if (submit) submit.disabled = !unavailable;
      const hint = this.querySelector('[data-interest-selection-helper]');
      if (hint) { hint.textContent = !exact && visible ? helper : ''; hint.hidden = !hint.textContent; }
      if (visible && this.querySelector('details')?.open) this.protectForm();

      const variantField = this.querySelector('[data-interest-variant]');
      const variantIdField = this.querySelector('[data-interest-variant-id]');
      const productUrlField = this.querySelector('[data-interest-product-url]');
      const returnTo = this.querySelector('[data-interest-return-to]');
      if (variantField) { variantField.value = variantTitle; variantField.disabled = !unavailable; }
      if (variantIdField) { variantIdField.value = variantId; variantIdField.disabled = !unavailable; }
      if (productUrlField) {
        productUrlField.disabled = !unavailable;
        if (unavailable) {
          const productUrl = new URL(this.dataset.productUrl, window.location.origin);
          productUrl.searchParams.set('variant', variantId);
          productUrlField.value = productUrl.toString();
          if (returnTo) returnTo.value = productUrl.pathname + productUrl.search + '#MaxlerAvailability-' + this.dataset.productId;
        } else {
          productUrlField.value = '';
          if (returnTo) returnTo.value = '';
        }
      }
      if (success) success.hidden = !unavailable || success.dataset.successVariantId !== variantId;
    }

    eventDetails() {
      return {
        productId: this.dataset.productId,
        productHandle: this.dataset.productHandle,
        variantId: this.dataset.variantId,
        country: this.dataset.country,
        locale: this.dataset.locale
      };
    }

    successStorageKey() {
      const {productId, variantId, country, locale} = this.eventDetails();
      return `maxler:variant-interest:${productId}:${variantId}:${country}:${locale}`;
    }

    handleSubmit(event) {
      if (this.hidden || !this.dataset.variantId || this.querySelector('[data-interest-fields]')?.disabled || this.querySelector('[data-interest-submit]')?.disabled) {
        event.preventDefault();
        return;
      }
      try {
        window.sessionStorage.removeItem(this.successStorageKey());
      } catch {}
      document.dispatchEvent(new CustomEvent('interest_request_attempt', {detail: this.eventDetails()}));
    }

    emitRequestSuccess() {
      const success = this.querySelector('[data-interest-request-success]');
      if (!success || success.hidden) return;

      const key = this.successStorageKey();
      try {
        if (window.sessionStorage.getItem(key)) return;
        window.sessionStorage.setItem(key, '1');
      } catch {}
      document.dispatchEvent(new CustomEvent('request_success', {detail: this.eventDetails()}));
    }
  }

  customElements.define('maxler-variant-interest', MaxlerVariantInterest);
})();
